<script setup lang="ts">
import { onMounted } from 'vue';
import { Capacitor } from '@capacitor/core';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { isPlatform } from '@ionic/vue';

import useTenant from '@/shared/composables/useTenant';
import useUtils from '@/shared/composables/useUtils';

// Init
const { t } = useI18n();
const router = useRouter();
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig, tenantStyles } = getTenantConfigAndStyles();
const { getCurrentWindowLocationOrigin } = useUtils();
const platform = Capacitor.getPlatform();

// onMountedHook
onMounted(() => {
	handleRedirect();
});

// Handle platform specific redirects
const handleRedirect = () => {
	if (platform === 'web' && !isPlatform('ios') && !isPlatform('android')) {
		window.location.href = getCurrentWindowLocationOrigin();
	} else if (isPlatform('android') && tenantConfig.value!.native_url_android) {
		window.location.href = tenantConfig.value!.native_url_android;
	} else if (isPlatform('ios') && tenantConfig.value!.native_url_apple) {
		window.location.href = tenantConfig.value!.native_url_apple;
	} else {
		window.location.href = getCurrentWindowLocationOrigin();
	}
};

// Set meta tags
const setMetaTags = () => {
	const head = document.head;

	// Create and append new meta tags
	const metaTags = [
		{ property: 'og:title', content: tenantStyles.value?.name || '' },
		{ property: 'og:type', content: 'website' },
		{ property: 'og:image', content: tenantStyles.value?.logo_url || '' },
		{ property: 'og:url', content: getCurrentWindowLocationOrigin() },
		{ property: 'og:description', content: tenantConfig.value?.welcome_line || '' },
	];

	metaTags.forEach((tag) => {
		const meta = document.createElement('meta');
		meta.setAttribute('property', tag.property);
		meta.setAttribute('content', tag.content);
		head.appendChild(meta);
	});
};

// Call setMetaTags in onMounted
onMounted(() => {
	setMetaTags();
	handleRedirect();
});
</script>

<template>
	<ion-content>
		<div class="flex flex-col items-center justify-center h-full px-4">
			<ion-button color="tertiary" class="w-full" shape="round" @click="router.push('/dashboard')">
				{{ t('share_app.go_to_dashboard') }}
			</ion-button>
		</div>
	</ion-content>
</template>

<style lang="scss" scoped></style>
